module.exports = __webpack_public_path__ + "static/v1.e-0e7fba2513ee68d6b15807e654f16a5a.jpg";